import React from 'react';
import PropTypes from 'prop-types';

import LightMontlyHistogramContainerMobile from '../LightMontlyHistogramContainerMobile';

const MonthlyHistogramContainerMobile = (props) => {
  const { carousel } = props;
  const newProps = Object.assign({}, props, {
    skeletonType: 'SkeletonMonthlyHistogram'
  });
  newProps.carousel = Object.assign({}, carousel, { renderMonthlyBar: 'MonthlyHistogramBarV2' });
  return <LightMontlyHistogramContainerMobile {...newProps} />;
};

MonthlyHistogramContainerMobile.componentName = 'MonthlyHistogramContainerMobile';

MonthlyHistogramContainerMobile.propTypes = {
  /**
   * Define if carousel navigation
   */
  carousel: PropTypes.objectOf(PropTypes.any),
  /**
   * Parameters tracking
   */
  tracking: PropTypes.objectOf(PropTypes.any)
};

MonthlyHistogramContainerMobile.defaultProps = {
  carousel: {},
  tracking: {
    flexibleDates: false,
    passengerCount: 1,
    promoCode: 'EVERYMUNDO',
    eventType: 'monthlyHistogram' // TODO: Which eventType is this component's
  }
};

export default MonthlyHistogramContainerMobile;
